import { useIsMounted } from '@simplywallst/ui-core';
import { FairValueHistogramChart } from './components/FairValueHistogramChart';
import type { FairValueHistogramCompanyFragment } from './fairValueHistogramFragment';
import { FairValueHistogramSkeleton } from './components/FairValueHistogramSkeleton';

type Props = {
  company: FairValueHistogramCompanyFragment;
  height?: number;
};

export const FairValueHistogram = ({ company, height = 270 }: Props) => {
  const isMounted = useIsMounted();

  if (!isMounted) return <FairValueHistogramSkeleton height={height} />;

  return (
    <div className="grid gap-x2" id="fair-value-histogram-chart-wrapper">
      {company.valuationHistogram && (
        <FairValueHistogramChart company={company} height={height} />
      )}
    </div>
  );
};
